document.addEventListener('DOMContentLoaded', function() {
  const colorSwatchContainers = document.querySelectorAll('.card-color-swatches');
  
  colorSwatchContainers.forEach(container => {
    const swatches = container.querySelectorAll('.color-swatch');
    const productId = container.dataset.productId;
    const card = container.closest('.card-wrapper');
    const productImage = card.querySelector('.card__media img:first-child');
    
    if (!productImage) return;
    
    swatches.forEach(swatch => {
      swatch.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Remove active class from all swatches
        swatches.forEach(s => s.classList.remove('active'));
        
        // Add active class to clicked swatch
        this.classList.add('active');
        
        // Update product image
        const newImageSrc = this.dataset.variantImage;
        const newImageSrcset = this.dataset.variantImageSrcset;
        
        if (newImageSrc && productImage) {
          productImage.src = newImageSrc;
          if (newImageSrcset) {
            productImage.srcset = newImageSrcset;
          }
        }
      });
    });
  });
});